import React from "react";
import styled from "@emotion/styled";

import { TICKET_TYPE } from "@src/components/deungi/common/enum";
import { useFindOneTicketCount } from "@src/hooks/deungi/useTicketCount";

interface CommonExpertTicketItemProps {
    ticketTypeNumber: TICKET_TYPE;
    ticketTitle: string;
    ticketImage: string;
}

const CommonTicketItem = ({ ticketTypeNumber, ticketTitle, ticketImage }: CommonExpertTicketItemProps) => {
    const { data: ticketCount } = useFindOneTicketCount(ticketTypeNumber);
    return (
        <TicketItemStyle>
            <img src={ticketImage} />
            <h3>
                {ticketTitle}
                <label>{ticketCount?.curHaveCnt || 0}장</label>
            </h3>
        </TicketItemStyle>
    );
};

export default CommonTicketItem;

const TicketItemStyle = styled.div`
    display: flex;

    border-radius: 8px;
    padding: 12px 8px;
    transition: all 0.2s ease;
    background: #f6faff;

    & > h3 {
        color: #0c002c;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.4;
        text-align: center;
        margin: 4px auto 0;

        & > label {
            display: block;
            font-size: 14px;
            font-weight: 700;
            color: #0047ff;
            text-align: center;
        }
    }
    & > img {
        width: 38px;
        height: 38px;
        background: #fff;
        border-radius: 4px;
        padding: 6px;
        margin: auto;
    }
`;
